<script>
    import { MINIMUM_LENGTH_QUERY } from './config'
    import { getSearchResults } from './search'
    import Result from './Result.svelte'
    let search = '';
    let searchResults = [];
    $: if (search.length > MINIMUM_LENGTH_QUERY) {
        const prom = getSearchResults(search)
        prom.then(result => searchResults = result)
    }
    // let onChange
    // $: onChange = () => console.log(search)
</script>

<input style="margin-bottom: 2em;" bind:value={search} type=text>
{#if searchResults.length}
    {#each searchResults as searchResult}
        <Result result={searchResult._source}/>
        <hr>
    {/each}
{:else}
    {#if search}
        No results.
    {/if}
{/if}
